import { Alert, Select } from '@indipia/ui-core'
import type { ForemanChangeResult } from '../api/foremanApi'
import { PARTNER_CHANGE_REASONS, PARTNER_CHANGE_REASON_PLACEHOLDER } from '../constants/foremanPlan'

// 확정 반장 변경 경고 + 변경 사유 선택 (기획서 #gdWarn · #gdWhy).
// 간트 상세창 PartnerCard 와 시공반장 팝업(SigongPopup) 행이 함께 쓴다.

interface Props {
  /** 지금 확정된 반장 이름 — 배정 취소 카톡을 받는 사람 */
  previousName: string | null
  reason: string
  onReasonChange: (reason: string) => void
  disabled?: boolean
  className?: string
}

export function ForemanChangeNotice({ previousName, reason, onReasonChange, disabled, className }: Props) {
  return (
    <div className={className} onMouseDown={e => e.stopPropagation()}>
      <Alert kind="warning">
        이미 일정을 확정한 반장님이에요. 바꾸면 <b>{previousName || '현재'}</b> 반장님께 &lsquo;배정 취소&rsquo; 카톡이 가요.
      </Alert>
      <Select
        aria-label="변경 사유"
        size="sm"
        className="!max-w-none"
        style={{ marginTop: 6 }}
        value={reason}
        disabled={disabled}
        onChange={e => onReasonChange(e.target.value)}
      >
        <option value="">{PARTNER_CHANGE_REASON_PLACEHOLDER}</option>
        {PARTNER_CHANGE_REASONS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
      </Select>
    </div>
  )
}

/**
 * 확정 반장 변경 결과 문구 (기획서 L3139).
 * cancelNoticed 는 서버가 알림톡 '배정 취소' 안내 호출을 마쳤다는 뜻일 뿐 반장 도달 보장이 아니므로, 발송 완료로 단정하는 문구를 쓰지 않는다.
 */
export function foremanChangeResultMessage(r: ForemanChangeResult, newName: string, previousName: string | null): string {
  const prev = previousName || '이전'
  const head = r.sendNow
    ? `${newName} 반장님께 일정확인 카톡을 보냈어요`
    : `${newName} 반장님으로 바꿨어요`
  let cancel: string
  if (r.sendNow) {
    cancel = r.cancelNoticed
      ? ` · ${prev} 반장님께 배정 취소 카톡 발송`
      : ` · ${prev} 반장님께 배정 취소 카톡은 보내지 못했어요`
  } else {
    // 저장(sendNow=false)은 취소 안내를 보내지 않고, 새 반장 일정확인 발송 시 함께 보낸다(서버 대기 기록)
    cancel = r.cancelNoticePending
      ? ` · 일정확인을 보낼 때 ${prev} 반장님께 배정 취소 카톡이 같이 가요`
      : ''
  }
  const imminent = r.imminentWarning ? ' · 착공이 임박했어요' : ''
  return `${head}${cancel}${imminent}`
}
